<h1 mat-dialog-title>Error</h1>
  <div mat-dialog-content>
    <p>{{ data.errorMessage }}<p>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial>Ok</button>
  </div>


// WEBPACK FOOTER //
// ./src/app/private/private.component.ts.AppErrorDialogComponent.html